// Source unique de la version affichée dans l'interface.
//
// La valeur est injectée au build à partir de `package.json` via la variable
// `REACT_APP_VERSION` (voir les scripts `start`/`build`, qui passent
// `$npm_package_version`). On garde une valeur de repli alignée sur
// `package.json` au cas où la variable d'environnement n'est pas définie
// (ex. import dans un test unitaire).
//
// Convention : chaque release est taguée `vX.Y.Z` dans git, en phase avec ce
// numéro. Bumper `package.json` puis créer le tag correspondant.
export const APP_VERSION = process.env.REACT_APP_VERSION || '0.2.0';
